<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h3>Import Exceptions Log ({{ exceptions.length }} errors)</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-alert type="warning" text class="my-4">
                The following items could not be imported due to validation
                errors. Please review and correct them before importing again.
            </v-alert>
            <v-data-table
                :headers="headers"
                :items="exceptions"
                class="elevation-0"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                :height="$vuetify.breakpoint.mdAndDown ? '50vh' : '60vh'"
                fixed-header
            >
                <template v-slot:[`item.createdOn`]="{ item }">
                    <span>{{ formatDate(item.createdOn) }}</span>
                </template>
                <template v-slot:[`item.errors`]="{ item }">
                    <ul class="error-list pl-4 my-2">
                        <li
                            v-for="(error, index) in item.errors"
                            :key="index"
                            class="error--text"
                        >
                            {{ error }}
                        </li>
                    </ul>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="secondary" @click="close"> Close </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="clearExceptions" :loading="loading">
                Clear All Exceptions
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import moment from 'moment'

export default {
    name: 'UcCodesExceptions',
    props: {
        exceptions: {
            type: Array,
            default: () => [],
        },
        settingId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        headers: [
            {
                text: 'UC CODE',
                value: 'name',
                sortable: false,
                width: '120',
            },
            {
                text: 'CONSECUTIVE',
                value: 'consecutive',
                sortable: false,
                width: '120',
            },
            {
                text: 'SUPPLIER',
                value: 'supplier',
                sortable: false,
                width: '120',
            },
            {
                text: 'AAMA',
                value: 'aama',
                sortable: false,
                width: '80',
            },
            {
                text: 'COVERING',
                value: 'covering',
                sortable: false,
                width: '110',
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                sortable: false,
                width: '180',
            },
            {
                text: 'ERRORS',
                value: 'errors',
                sortable: false,
                width: '250',
            },
            {
                text: 'DATE',
                value: 'createdOn',
                sortable: false,
                width: '150',
            },
        ],
    }),
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        async clearExceptions() {
            try {
                this.loading = true
                await API.clearFinishAndUCCodeExceptions(this.settingId)
                this.$emit('cleared')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        formatDate(date) {
            if (!date) return ''
            // handle Firestore timestamp
            if (date._seconds || date.seconds) {
                return moment
                    .unix(date._seconds || date.seconds)
                    .format('YYYY-MM-DD HH:mm:ss')
            }
            // handle regular date
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
    },
}
</script>

<style scoped>
.v-data-table {
    border: 1px solid #eeeeee;
}
.error-list {
    list-style-type: disc;
    margin: 0;
}
.error-list li {
    margin-bottom: 4px;
}
</style>
